import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import { Input } from "../utility/HexInput/InputBox";
import Hexapi from "../utility/HexAPI/Hexapi";
import { TimeFormatterV2 } from "../TimeFormatter";
import NotificationImportantIcon from "@mui/icons-material/NotificationImportant";
import IconButton from "@mui/material/IconButton";
import { Spinner } from "react-bootstrap";
import DataTable from "./table/DataTable";
import { IoMdAdd } from "react-icons/io";
import Tooltip from "@mui/material/Tooltip";
import Swal from "sweetalert2";

function Reminder(props) {
  const [addremindermodal, setaddremindermodal] = useState(false);
  const [remindermodal, setremindermodal] = useState(false);
  const [reminderdata, setreminderdata] = useState([]);
  const [reminderdate, setreminderdate] = useState(
    TimeFormatterV2(new Date(), "fulldate", "YYYY-MM-DD HH:mm:ss")
  );
  const [description, setdescription] = useState("");
  const [reminderforid, setreminderforid] = useState(props.AgentID);
  const [reminderforarr, setreminderforarr] = useState([]);
  const [getdataloading, setgetdataloading] = useState(true);
  const [isapihitcomplete, setisapihitcomplete] = useState(false);
  const [isdatafound, setisdatafound] = useState(false);
  const SubmitReminder = async () => {
    const obj = {
      query: `[dbo].[HCMS_Proc_Reminder_Submit] @AgentID='{0}',@LeadID='{1}',@ReminderDateTime='{2}',@Description='{3}',@ReminderForID='{4}'`,
      queryArr: [
        `${props.AgentID}`,
        `${props.EnquiryID}`,
        `${reminderdate}`,
        `${description}`,
        `${reminderforid}`,
      ],
    };
    try {
      const resp = await Hexapi(obj);
      console.log(resp);
      if (resp[""][0].command === 1) {
        Swal.fire({
          title: "Success",
          text: resp[""][0].msg,
          icon: "success",
        }).then(() => {
          getlist();
          setaddremindermodal(false);
          setremindermodal(true);
          setdescription("");
          setreminderdate(TimeFormatterV2(new Date(), "fulldate", "YYYY-MM-DD HH:mm:ss"))
        });
      } else if (resp[""][0].command === 0) {
        Swal.fire("Error", resp[""][0].msg, "error");
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };
  const getdata = async () => {
    setgetdataloading(true);
    const obj = {
      query: `[dbo].[HCMS_Proc_Reminder_GetData] @AgentID='{0}'`,
      queryArr: [`${props.AgentID}`],
    };
    try {
      const resp = await Hexapi(obj);
      console.log(resp["reminderfor"]);
      setreminderforarr(resp["reminderfor"]);
      setgetdataloading(false);
      setreminderforid(props.AgentID)
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };
  const getlist = async () => {
    setisdatafound(false);
    setisapihitcomplete(false);
    const obj = {
      query: `[dbo].[HCMS_Proc_Reminder_GetList] @AgentID='{0}',@LeadID='{1}'`,
      queryArr: [`${props.AgentID}`, `${props.EnquiryID}`],
    };
    try {
      const resp = await Hexapi(obj);
      console.log(resp);
      setreminderdata(resp["reminderlist"]);
      setTimeout(() => {
        if (resp["reminderlist"] != undefined) {
          if (resp["reminderlist"].length > 0) {
            setisdatafound(true);
          }
        } else {
          setisdatafound(false);
        }
        setisapihitcomplete(true);
      }, 300);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };
  return (
    <>
      <Tooltip title="Add Reminder">
        <IconButton
          onClick={() => {
            getlist();
            setremindermodal(true);
          }}
        >
          <NotificationImportantIcon />
        </IconButton>
      </Tooltip>
      <Modal
        scrollable={true}
        fullscreen
        show={remindermodal}
        onHide={() => setremindermodal(false)}
        keyboard={false}
        backdrop="static"
        style={{ backgroundColor: "rgba(0,0,0,0.9)" }}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Reminder List</Modal.Title>
          <IconButton
            onClick={() => {
              getdata();
              setaddremindermodal(true);
            }}
          >
            <IoMdAdd />
          </IconButton>
        </Modal.Header>
        <Modal.Body>
          {isapihitcomplete ? (
            isdatafound ? (
              <>
                <DataTable
                  data={reminderdata}
                  uppercase={false}
                  inputProps={{
                    thead: {
                      backgroundColor: "rgb(18, 80, 172)",
                      color: "#fff",
                      textTransform: "capitalize",
                    },
                  }}
                  pagination={{
                    show: false,
                    rowsPerPage: 1,
                    rowsPerPageOptions: [
                      1,
                      3,
                      5,
                      15,
                      50,
                      100,
                      { label: "All", value: -1 },
                    ],
                  }}
                />
              </>
            ) : (
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  height: "90vh",
                }}
              >
                <h3 style={{ fontFamily: "sans-serif", color: "#eea606" }}>
                  No Records!
                </h3>
              </div>
            )
          ) : (
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                width: "100%",
                height: "50vh",
                alignItems: "center",
              }}
            >
              <Spinner color="red" animation="border" variant="dark" />
            </div>
          )}
        </Modal.Body>
      </Modal>
      <Modal
        centered
        show={addremindermodal}
        onHide={() => {
          setaddremindermodal(false);
          setdescription("");
          setreminderdate(TimeFormatterV2(new Date(), "fulldate", "YYYY-MM-DD HH:mm:ss"))
        }}
        keyboard={false}
        backdrop="static"
        style={{ backgroundColor: "rgba(0,0,0,0.9)" }}
      >
        <Modal.Header closeButton>
          <Modal.Title>Add Reminder</Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ overflowX: "hidden" }}>
          {!getdataloading ? (
            <div>
              <h6>
                Enquiry ID : <span>{props.EnquiryID}</span>
              </h6>
              <label
                htmlFor="nextFollowDate"
                className="form-label fw-semibold"
                style={{ fontWeight: 500 }}
              >
                Reminder Date Time <span className="text-danger">*</span>
              </label>
              <input
                id="nextFollowDate"
                type="datetime-local"
                className="form-control custom-datetime"
                value={reminderdate}
                onChange={(e) =>
                  setreminderdate(
                    TimeFormatterV2(
                      e.target.value,
                      "fulldate",
                      "YYYY-MM-DD HH:mm:ss"
                    )
                  )
                }
                required
              />
              <Input
                htmlFor={"Description"}
                type={"text"}
                label={" Description"}
                labelStyle={{ fontWeight: "600" }}
                required={true}
                value={description}
                onChange={(e) => setdescription(e.target.value)}
              />
              <label style={{ fontWeight: 600 }}>Reminder For</label>
              <span className="error" style={{ color: "red" }}>
                *
              </span>
              <select
                className="form-control"
                aria-label="Default select example"
                onChange={(e) => {
                  setreminderforid(e.target.value);
                }}
                value={reminderforid}
              >
                <option value="" disabled selected>
                  Select
                </option>
                {reminderforarr.map((item) => {
                  return (
                    <option value={item.reminderforid} key={item.reminderforid}>
                      {item.agentname}
                    </option>
                  );
                })}
              </select>
              <center>
                <button
                  type="submit"
                  className=" mt-3 data-verify"
                  onClick={(e) =>
                    SubmitReminder(
                      TimeFormatterV2(
                        e.target.value,
                        "fulldate",
                        "YYYY-MM-DD HH:mm:ss"
                      )
                    )
                  }
                >
                  Set Reminder
                </button>
              </center>
            </div>
          ) : (
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                width: "100%",
                height: "70vh",
                alignItems: "center",
              }}
            >
              <Spinner color="red" animation="border" variant="dark" />
            </div>
          )}
        </Modal.Body>
      </Modal>
    </>
  );
}

export default Reminder;
